import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { CSVReader } from 'react-papaparse';
import Header from '../../Header';
import { collectionActions } from '../../Actions';
import './CollectionDashboard.css'

class CollectionDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collectionOptions: [],
            fileOptions: [],
            fileSelected: null,
            file_headers: {},
            dropFile: [],
            errors: {},
            isLoad: true,
            token: "",
            message: false
        }
        this.fileUpload = React.createRef();
    }

    handleFileTypeChange = fileSelected => {
        this.setState({ fileSelected });
    };

    UNSAFE_componentWillMount() {
        const { REACT_APP_USER_ID, REACT_APP_SECRET_KEY, REACT_APP_TYPE } = process.env;
        const authData = {
            user_id: REACT_APP_USER_ID,
            secret_key: REACT_APP_SECRET_KEY,
            type: REACT_APP_TYPE
        }
        this.props.postAuth(authData)
    }

    handleOnDrop = data => {
        this.setState({ dropFile: data })
    }

    handleOnError = (err, file, inputElem, reason) => {
        console.log(err)
    }

    submitFile = () => {
        const { fileSelected, file_headers, dropFile, errors, token } = this.state;
        const error = errors;
        const fileResult = file_headers[fileSelected && fileSelected.value];
        const fileData = (dropFile && dropFile[0] && dropFile[0]['data']) || [];
        const isMatch = fileResult.every(fr => fileData.includes(fr))

        if (fileSelected === null) {
            error['file_type'] = "Please Select File Type"
        } else {
            error['file_type'] = ""
        }

        if (dropFile.length === 0) {
            error['file_upload'] = "Please Drag and Drop CSV File"
        } else {
            error['file_upload'] = ""
        }

        if (isMatch) {
            error['header_not_match'] = ""
        } else {
            error['header_not_match'] = "Header are not match"
        }

        if (Object.values(error).some(e => e !== "")) {
            this.setState({ errors: error, message: false })
            return
        }

        if (isMatch && token.length) {
            const collectionUpload = {
                file_type: fileSelected.value,
                file: this.fileUpload.current.state.file
            }
            this.props.postUploadCollections(collectionUpload, token)
        }

        this.setState({
            dropFile: [],
            fileSelected: null,
            message: true
        })

        this.fileUpload.current.inputFileRef.current.value = '';
        this.fileUpload.current.setState({
            hasFiles: false,
            progressBar: 0,
            displayProgressBarStatus: "none",
            file: "",
            timeout: null
        });
    }

    async UNSAFE_componentWillReceiveProps(nextProps) {
        const { isLoad } = this.state;
        const { collection } = nextProps;
        const authToken = await collection.authitems && collection.authitems.response && collection.authitems.response.auth && collection.authitems.response.auth.token;
        if (authToken) {
            if (isLoad) {
                const TOKEN = authToken;
                this.props.getCollections(TOKEN);
                this.setState({ isLoad: false, token: TOKEN })
            }
        }
        const nextFile = await collection.items && collection.items.data && collection.items.data.attributes;
        if (nextFile) {
            const fileOptions = nextFile.file_type.map(fileType => ({
                label: fileType.split('_').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' '),
                value: fileType
            }))
            this.setState({ fileOptions, file_headers: nextFile.file_headers })
        }
    }

    render() {
        const { fileOptions, fileSelected, errors, message } = this.state;
        const { collection } = this.props;
        return (
            <div className="container-fluid p-0">
                <div className="col-md-12 p-0">
                    <Header />
                </div>
                <div className="col-md-12" style={{ position: 'absolute', top: '21%' }}>
                    {Object.keys(errors) && Object.keys(errors).map(err => {
                        return (
                            <>
                                {
                                    errors[err].length ?
                                        <div key={`collection_${err}`} className="col-md-12 d-flex mb-2">
                                            <div className="col-md-4 m-auto">
                                                <div className="alert alert-danger m-auto" role="alert">
                                                    {errors[err]}
                                                </div>
                                            </div>
                                        </div> : null
                                }
                            </>
                        )
                    })}
                    {collection.error && collection.error.length && (
                        <div className="col-md-12 d-flex" style={{ position: 'absolute', top: '21%' }}>
                            <div className="col-md-4 m-auto">
                                <div className="alert alert-danger m-auto" role="alert">
                                    {collection.error.map(err => <Fragment key={err.detail}>{err.detail}</Fragment>)}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {
                    collection.authitems && collection.authitems.error ? <div className="col-md-12 d-flex" style={{ position: 'absolute', top: '21%' }}>
                        <div className="col-md-4 m-auto">
                            <div className="alert alert-danger m-auto" role="alert">
                                {collection.authitems.error.code === "ER-AUTH-112" ? collection.authitems.error.message : collection.authitems.error.code === "ER-EN-000" ? collection.authitems.error.message : collection.authitems.error.code === "ER-AUTH-110" ? collection.authitems.error.message : ""}
                            </div>
                        </div></div> : null
                }
                {
                    collection.postautherror ? <div className="col-md-12 d-flex" style={{ position: 'absolute', top: '21%' }}>
                        <div className="col-md-4 m-auto">
                            <div className="alert alert-danger m-auto" role="alert">
                                {collection.postautherror}
                            </div>
                        </div></div> : null
                }
                {
                    collection.successItems && message ? <div className="col-md-12 d-flex" style={{ position: 'absolute', top: '21%' }}>
                        <div className="col-md-4 m-auto">
                            <div className="alert alert-success m-auto" role="alert">
                                {collection.successItems.message}
                            </div>
                        </div></div> : null
                }
                <div className="d-flex col-md-12 p-0">
                    <div className="p-3 sidebar" style={{ width: 75, poition: 'fixed' }}>
                        <img src='/images/Group-2805.png' alt="back arrow" width="43px" height="43px" />
                    </div>
                    <div className="p-0 col-md-11 mtop">
                        <div className="col-md-4 m-auto pl-4 pr-4">
                            <Select
                                placeholder="Select..."
                                value={fileSelected}
                                onChange={this.handleFileTypeChange}
                                options={fileOptions}
                            />
                        </div>
                        <div className="col-md-4 p-0 m-auto">
                            <div className="container mt-4 pl-4 pr-4">
                                <CSVReader
                                    onDrop={this.handleOnDrop}
                                    onError={this.handleOnError}
                                    ref={this.fileUpload}
                                    className="p15"
                                >
                                    <span>Drop CSV file here or click to upload.</span>
                                </CSVReader>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mt-3 d-flex sub-btn padd0 text-center">
                    <div className="col-md-12 paddlr20 m-auto grid padd0">
                        <button type="button" className=" btn btn-success submit-btn" onClick={this.submitFile}>Submit <img src="/images/arrow.png" alt="icon" className="ml-3 mb-1 dispNone" /></button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapState(state) {
    const { collection } = state;
    return { collection };
}

const actionCreators = {
    getCollections: collectionActions.getCollections,
    postUploadCollections: collectionActions.postUploadCollections,
    postAuth: collectionActions.postAuth
};

export default connect(mapState, actionCreators)(CollectionDashboard);
